import * as React from 'react';
import type { Component } from 'grapesjs';
import { 
  DragIndicator,
  KeyboardArrowRight,
  MoreHoriz,
  Visibility,
  VisibilityOff,
} from '@mui/icons-material';

interface LayerItemProps {
  component: Component;
  level: number;
  draggingCmp?: Component;
  dragParent?: Component;
}

export default function LayerItem({ component, level, draggingCmp, dragParent }: LayerItemProps) {
  const isHidden = component.get('visible') === false;
  const isDragging = draggingCmp === component;
  const isParent = dragParent === component;
  const components = component.components();
  const hasChildren = components.length > 0;

  return (
    <div 
      data-layer-item 
      className="relative" 
      ref={(el: HTMLDivElement | null) => {
        if (el) {
          (el as any).__cmp = component;
        }
      }}
    >
      <div 
        className={`
          flex items-center gap-2 px-3 py-2 transition-colors duration-150
          ${isDragging ? 'opacity-50' : ''}
          ${isParent ? 'bg-blue-50' : 'hover:bg-black/5'}
          ${level > -1 ? 'border-t border-gray-100/50' : ''}
        `}
        style={{ paddingLeft: `${(level + 1) * 12 + 12}px` }}
      >
        <DragIndicator className="w-4 h-4 text-gray-400 cursor-move" />
        <span className="flex-grow text-sm text-gray-700 truncate">
          {component.getName()}
        </span>
        <button className="p-1 rounded-full hover:bg-black/5">
          {isHidden ? (
            <VisibilityOff className="w-4 h-4 text-gray-400" />
          ) : (
            <Visibility className="w-4 h-4 text-gray-400" />
          )}
        </button>
        {hasChildren && (
          <KeyboardArrowRight className="w-5 h-5 text-gray-400" />
        )}
        <button className="p-1 rounded-full hover:bg-black/5">
          <MoreHoriz className="w-4 h-4 text-gray-400" />
        </button>
      </div>
      {hasChildren && (
        <div>
          {components.map((cmp) => (
            <LayerItem
              key={cmp.cid}
              component={cmp}
              level={level + 1}
              draggingCmp={draggingCmp}
              dragParent={dragParent}
            />
          ))}
        </div>
      )}
    </div>
  );
}
